const riskAssessmentSetupTabs = {
    TEMPLATES: "templates",
    SHARE_GROUPS: "shareGroups",
};

export default riskAssessmentSetupTabs;
